import { SALES_EMAIL_HREF } from "./contact";

export const PRICING_CTA = {
  eyebrow: "Get started",
  title: "Design it, see it, hold it.",
  lede: "Choose the level of access that fits how your team designs, develops, and produces.",
  primary: { label: "Pricing", href: "/start" },
  secondary: { label: "Talk to us", href: SALES_EMAIL_HREF, external: true },
} as const;
